import { getLoginDataResponseSchema, initiateLoginResponseSchema } from '@/api/SE/login/schemas';
import { apiRequest } from '@/api/utils/api';

export const initiateLogin = (nationalNumber?: string | void) =>
  apiRequest({
    url: '/se/login',
    method: 'POST',
    schema: initiateLoginResponseSchema,
    data: { nationalNumber },
  });

export const getLoginData = (orderId: string) =>
  apiRequest({ url: `/se/login/${orderId}`, method: 'GET', schema: getLoginDataResponseSchema });
